import { useRequestHeaders, useRoute } from '#imports'

import { HttpHeader } from '@backmarket/http-api'

export const WEBVIEW_USER_AGENT = 'bm-mobile-app-webview'

export function useIsWebview() {
  const route = useRoute()
  const headers = useRequestHeaders()
  const userAgent =
    headers[HttpHeader.USER_AGENT] ?? window?.navigator?.userAgent

  return (
    Boolean(route.meta?.isWebview) || userAgent?.includes(WEBVIEW_USER_AGENT)
  )
}
